import styled from "styled-components";

export const ToggleSwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  flex-shrink: 0;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const ToggleSlider = styled.span<{ $checked: boolean }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ $checked, theme }) =>
    $checked ? theme.colors.yellow : theme.colors.gray400};
  transition: 0.4s;
  border-radius: 20px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: ${({ $checked, theme }) =>
      $checked ? theme.colors.darkBg : theme.colors.white};
    transition: 0.4s;
    border-radius: 50%;
    transform: ${({ $checked }) =>
      $checked ? "translateX(20px)" : "translateX(0)"};
  }
`;

export const CircularToggleContainer = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 27.04px;
  height: 27.04px;
  min-width: 27.04px;
  min-height: 27.04px;
  flex-shrink: 0;
  overflow: visible;
  cursor: pointer;
`;

export const CircularToggleButton = styled.span<{ $checked: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27.04px;
  height: 27.04px;
  min-width: 27.04px;
  min-height: 27.04px;
  aspect-ratio: 1;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.colors.yellow};
  background-color: ${({ $checked, theme }) =>
    $checked ? theme.colors.yellow : "transparent"};
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  user-select: none;
  padding: 0;
  text-align: center;
  transition:
    background-color 0.28s ease,
    box-shadow 0.28s ease,
    transform 0.18s ease;

  &:active {
    transform: scale(0.94);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active {
      transform: none;
    }
  }
`;

export const CircularToggleText = styled.span<{
  $visible: boolean;
  $isOn: boolean;
}>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $isOn, theme }) =>
    $isOn ? theme.colors.black : theme.colors.yellow};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: scale(${({ $visible }) => ($visible ? 1 : 0.82)});
  transition:
    opacity 0.22s ease,
    transform 0.22s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    transform: none;
  }
`;

export const InlineToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  overflow: visible;
  flex-shrink: 0;
`;

export const InlineToggleLabel = styled.label`
  color: ${({ theme }) => theme.colors.yellow};
  font-size: 15.4px;
  font-weight: 700;
  line-height: 18px;
  cursor: pointer;
  white-space: nowrap;
`;
